/**
 * Fired once by the shorts feed when the entry video renders its first frame.
 * Lives here (and not in a plugin) so components on the critical path can
 * subscribe without pulling plugin setup code into their chunk.
 */
export const SHORTS_FIRST_FRAME_EVENT = 'bifrost:shorts-first-frame';

/**
 * Fired by the player when unmuted autoplay was denied by the browser and it
 * fell back to muted playback. The page listens to sync the sound button and
 * to re-enable audio on the user's first gesture.
 */
export const SHORTS_AUTOPLAY_MUTED_EVENT = 'bifrost:shorts-autoplay-muted';

/** Disparado uma vez quando o buffer do ativo fica saudavel: solta dados leves. */
export const SHORTS_BUFFER_HEALTHY_EVENT = 'bifrost:shorts-buffer-healthy';

/** Buffer saudavel sustentado: solta o trabalho pesado (vizinhos, telemetria). */
export const SHORTS_BUFFER_SUSTAINED_EVENT = 'bifrost:shorts-buffer-sustained';
